export default __webpack_public_path__ + "static/media/green.d65edba7.png";